package xyz.luan.bpc.operation

import xyz.luan.bpc.inverse
import xyz.luan.bpc.parser.ParsingContext
import xyz.luan.bpc.roundTo

enum class CentreOperation(
    val value: String,
) {
    SQUARE("square") {
        override fun process(value: Double): Double = value * value
    },
    DIAMOND("diamond") {
        override fun process(value: Double): Double = inverse(value)
    },
    ROUND_1("round1") {
        override fun process(value: Double): Double = roundTo(value, 1)
    },
    ROUND_2("round2") {
        override fun process(value: Double): Double = roundTo(value, 2)
    },
    ROUND_3("round3") {
        override fun process(value: Double): Double = roundTo(value, 3)
    },

    ;

    abstract fun process(value: Double): Double

    companion object {
        fun parse(context: ParsingContext, value: String): CentreOperation {
            return entries.find { it.value == value }
                ?: context.fail("Invalid central operation value: $value")
        }
    }
}
